import { action } from 'typesafe-actions';

import { HeaderActionsEnum } from '../enums/HeaderActionsEnum';

export const setIsHeaderStickedAction = (isSticked: boolean) => action(HeaderActionsEnum.SET_IS_STICKED, { isSticked });
export const setDirtyResultDecisionGuid = (dirtyResultDecisionGuid: string | undefined) =>
  action(HeaderActionsEnum.SET_IS_DIRTY_RESULT_DECISION, { dirtyResultDecisionGuid });
export const setDirtyActGuid = (dirtyActGuid: string | undefined) =>
  action(HeaderActionsEnum.SET_IS_DIRTY_ACT, { dirtyActGuid });
export const setDirtyAgreementGuid = (dirtyAgreementGuid: string | undefined) =>
  action(HeaderActionsEnum.SET_IS_DIRTY_AGREEMENT, { dirtyAgreementGuid });
export const setInitHash = (hash: string | undefined) => action(HeaderActionsEnum.SET_INIT_HASH, { hash });
